// ---------------------------------------------------------------------------
// Centralized application configuration
// ---------------------------------------------------------------------------
// Every piece of runtime config lives here. Components and hooks import from
// this module instead of reading `process.env` or hardcoding URLs inline.
// ---------------------------------------------------------------------------

function buildWsUrl(): string {
  if (process.env.NEXT_PUBLIC_WS_URL) {
    return process.env.NEXT_PUBLIC_WS_URL;
  }
  if (typeof window !== "undefined") {
    const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${proto}//${window.location.host}/api/ws`;
  }
  return "ws://localhost:8000/api/ws";
}

export const config = {
  /** Full API base URL including the `/api` path prefix. */
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000/api",

  /**
   * Root server URL *without* the `/api` prefix.
   * Useful for constructing file-download or static-asset URLs.
   */
  get serverUrl(): string {
    const api = this.apiUrl;
    return api.endsWith("/api") ? api.slice(0, -4) : api;
  },

  /** WebSocket base URL (derived from env or current page origin). */
  wsUrl: buildWsUrl(),

  /** Human-readable app name used in titles, meta tags, etc. */
  appName: "ICETracker",

  /** One-line app description for meta tags & landing pages. */
  appDescription: "Immigration & Customs Enforcement Case Tracking System",

  /** Maximum file upload size in bytes (100 MB). */
  maxUploadSize: 100 * 1024 * 1024,

  /** File extensions accepted by the evidence uploader. */
  supportedFileTypes: [
    ".pdf",
    ".jpg",
    ".jpeg",
    ".png",
    ".mp4",
    ".mov",
    ".doc",
    ".docx",
  ],

  /** Pagination defaults used by list endpoints. */
  pagination: {
    defaultPageSize: 20,
    maxPageSize: 100,
  },
} as const;
